import { useEffect, useState } from "react";
import Boards from './Boards';
import SettingsView from './SettingsView';
import View from "./View";
import Sidebar from './Sidebar';
import { makeBEM } from "../global/utils";

function ViewsManager() {
    const [activeView, setActiveView] = useState(0);
    const moduleName = 'views-manager';

    useEffect(() => {
        setActiveView(0);
    }, []);

    const handlePush = () => setActiveView(1) ;
    const handlePop = () => setActiveView(0);

    const toggleViews = () => {
        if ( activeView === 0 ) {
            setActiveView(1);
        } else {
            setActiveView(0);
        }
    }

   return (
        <div className={moduleName}>
            <Sidebar showSettingsViewAction={toggleViews}/>
            <div className={ makeBEM(moduleName, 'views-wrapper') }>
                
                {
                    <View 
                        index={0}
                        show={activeView === parseInt(0)}
                        key={0}
                    >   
                        <Boards switchViewAction={handlePush}/>   
                    </View>
                }
                {
                    <View 
                        index={1}
                        show={activeView === parseInt(1)}
                        key={1}
                        customClass="pushed"
                    >
                        
                        <SettingsView switchViewAction={handlePop}/>
                    </View>
                }
                
            </div>
        </div>
   );
}

export default ViewsManager;